<template>
    <nuxt-link :to="getCustomLocalePath(post)" prefetch class="no-underline">
        <v-card
            :class="{
                'card--flex-vertical': true,
                'card--featuredProducts': true,
                'justify-space-between': true,
            }"
        >
            <v-card-text
                :class="{
                    'card-text--featuredProducts': true,
                    'text-center': true,
                    'd-flex': true,
                    'align-center': true,
                }"
                style="height: 180px"
            >
                <EmbedSanityImage
                    v-if="
                        post.sanityThumbnail &&
                        post.sanityThumbnail.selectedImage
                    "
                    :selectedImage="
                        post.sanityThumbnail &&
                        post.sanityThumbnail.selectedImage
                    "
                    :alt="post.sanityThumbnail && post.sanityThumbnail.alt"
                    height="136"
                    width="136"
                    :classes="`align-end`"
                    :img-classes="`card-img--featuredProducts`"
                    :image-align="`none`"
                    :fit="`fill`"
                />
            </v-card-text>
            <!-- <v-spacer></v-spacer> -->
            <v-card-title
                :class="{
                    'card-title--featuredProducts': true,
                    'text-center': true,
                    squeeze: true,
                }"
            >
                <span class="no-underline nav-a--text2 card">
                    <span>{{
                        $i18n.locale ? post.title[$i18n.locale] : post.title.en
                    }}</span>
                </span>
            </v-card-title>
            <!-- <v-spacer></v-spacer> -->
            <v-card-actions class="card-actions--featuredProducts">
                <v-btn color="primary" outlined
                    ><TranslatableStringComponent
                        :tstring="{ string: 'shopNow' }"
                    />
                </v-btn>
            </v-card-actions>
        </v-card>
    </nuxt-link>
</template>
<script>
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'CardSingleProduct',
    components: {
        EmbedCloudinary2,
        TranslatableStringComponent,
        EmbedSanityImage,
    },
    props: {
        post: {
            type: Object,
            default: null,
        },
        imgCrop: {
            type: String,
            default: 'fit',
        },
    },
    methods: {
        fallbackImage(post, part, lang) {
            const fallback = {
                imageId: 'c3controls-icon',
                imageDir: 'logos',
                alt: { en: 'c3controls', es: 'c3controls' },
            }
            const changeLandingPage =
                (post.changeLandingPage &&
                    post.setLandingPage &&
                    post.setLandingPage.thumbnail) ||
                false
            const thumb = post.thumbnail
                ? post.thumbnail
                : changeLandingPage
                ? post.setLandingPage.thumbnail
                : fallback
            if (thumb && thumb.imageId && thumb.imageDir) {
                if (part === 'imageId') {
                    return thumb.imageId
                } else if (part === 'imageDir') {
                    return thumb.imageDir
                } else if (part === 'alt') {
                    return thumb.alt || fallback.alt
                }
            }
            return fallback[part] || null
        },
    },
}
</script>
